import type { ComponentProps } from 'react';

import { Button } from '@/lib/shadcn/button';
import { cn } from '@/lib/utils';

// Low-emphasis ghost button — no background until hovered.
export function GhostButton({ className, ...props }: ComponentProps<typeof Button>) {
  return <Button variant="ghost" className={cn(className)} {...props} />;
}
